import { html } from "lit";
var icon_submit_default = () => html` <svg stroke-fill xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <g>
      <g>
        <g>
          <g>
            <path
              d="M20.45 0c.77 0 1.55.44 2.1 1l3.87 3.87c.55.55.88 1.33.88 2.1v2.21c0 .44-.44.88-.88.88s-1-.44-1-.88V6.97a1 1 0 0 0-.33-.77l-3.87-3.87c-.25-.29-.44-.44-.77-.44H2.87c-.66 0-1.11.55-1.11 1.11v22.43c0 .66.55 1.11 1.11 1.11h8.08c.44 0 .88.44.88.88s-.33 1-.88 1H2.87C1.21 28.42 0 27.09 0 25.43V2.99A2.96 2.96 0 0 1 2.87 0h17.58Z" />
          </g>
          <g stroke-linecap="round" stroke-width="2px">
            <path d="M11.9 19.05h15.41" />
            <path d="m27.31 19.05-5.78-5.69" />
            <path d="m27.31 19.05-5.78 5.69" />
          </g>
        </g>
      </g>
    </g>
  </svg>`;
export {
  icon_submit_default as default
};
//# sourceMappingURL=icon-submit.js.map
